import { UserData } from "../../hooks/FirstTimeWebSrn/Websrn";


const web = localStorage.getItem('server');

const initialState = {
    //website api's
    imageServer: `${web}/public/`,
    Login:`${web}/apk/login`,
    Web:`${web}/WebSrn`,
    // DashBoard Api's
    Fess:`${web}/apk/showFess`,
    // apiLink: 'https://hodattmobile.wasily.net',
    // apiLink: 'https://testattmobile.wasily.net',
    // apiLink: 'https://attmobile.xaosoft.com',
    // apiLink: 'https://attmobile.kandaharscience.com',
    // apiLink: 'https://attmobile.wordquran.com',
    // apiLink: 'https://attmobile.wasily.net',
    apiLink: 'https://attmobile.jamiahakeemulummat.com',
    // apiLink: 'http://localhost:4000',
};

const Api = (state = initialState) => {
        return state;
}
export default Api;
